export const FONT_SIZE = {
  xs: 10,
  s: 12,
  m: 14,
  l: 18,
  xl: 24,
};
